/**
 * Esqueletos con la forma de lo que viene. Se prefieren a un spinner porque
 * la pantalla no salta cuando llegan los datos: el espacio ya estaba ocupado.
 */
export function ListaCargando({ filas = 3 }) {
  return (
    <div className="lista" aria-busy="true" aria-label="Cargando opciones">
      {Array.from({ length: filas }, (_, i) => (
        <div key={i} className="esqueleto esqueleto-fila" />
      ))}
    </div>
  );
}

export function DiasCargando() {
  return (
    <div className="dias" aria-busy="true" aria-label="Cargando días">
      {Array.from({ length: 7 }, (_, i) => (
        <div key={i} className="esqueleto esqueleto-dia" />
      ))}
    </div>
  );
}

export function SlotsCargando({ cantidad = 8 }) {
  return (
    <div className="slots" aria-busy="true" aria-label="Cargando horarios">
      {Array.from({ length: cantidad }, (_, i) => (
        <div key={i} className="esqueleto esqueleto-slot" />
      ))}
    </div>
  );
}
